import { storableError } from '../../util/errors';
import { get, post } from '../../util/api';

// ================ Action types ================ //

export const CLEAR_STATE = 'app/AdminAssignmentsPage/CLEAR_STATE';

export const FETCH_USERS_REQUEST = 'app/AdminAssignmentsPage/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'app/AdminAssignmentsPage/FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'app/AdminAssignmentsPage/FETCH_USERS_ERROR';

export const FETCH_VOUCHERS_REQUEST = 'app/AdminAssignmentsPage/FETCH_VOUCHERS_REQUEST';
export const FETCH_VOUCHERS_SUCCESS = 'app/AdminAssignmentsPage/FETCH_VOUCHERS_SUCCESS';
export const FETCH_VOUCHERS_ERROR = 'app/AdminAssignmentsPage/FETCH_VOUCHERS_ERROR';

export const ASSIGN_VOUCHERS_REQUEST = 'app/AdminAssignmentsPage/ASSIGN_VOUCHERS_REQUEST';
export const ASSIGN_VOUCHERS_SUCCESS = 'app/AdminAssignmentsPage/ASSIGN_VOUCHERS_SUCCESS';
export const ASSIGN_VOUCHERS_ERROR = 'app/AdminAssignmentsPage/ASSIGN_VOUCHERS_ERROR';

// ================ Reducer ================ //

const initialState = {
  users: [],
  vouchers: [],
  fetchUsersInProgress: false,
  fetchUsersError: null,
  fetchVouchersInProgress: false,
  fetchVouchersError: null,
  assignmentInProgress: false,
  assignmentError: null,
};

export default function adminAssignmentsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CLEAR_STATE:
      return initialState;

    case FETCH_USERS_REQUEST:
      return { ...state, fetchUsersInProgress: true, fetchUsersError: null };
    case FETCH_USERS_SUCCESS:
      return { ...state, fetchUsersInProgress: false, users: payload };
    case FETCH_USERS_ERROR:
      return { ...state, fetchUsersInProgress: false, fetchUsersError: payload };

    case FETCH_VOUCHERS_REQUEST:
      return { ...state, fetchVouchersInProgress: true, fetchVouchersError: null };
    case FETCH_VOUCHERS_SUCCESS:
      return { ...state, fetchVouchersInProgress: false, vouchers: payload };
    case FETCH_VOUCHERS_ERROR:
      return { ...state, fetchVouchersInProgress: false, fetchVouchersError: payload };

    case ASSIGN_VOUCHERS_REQUEST:
      return { ...state, assignmentInProgress: true, assignmentError: null };
    case ASSIGN_VOUCHERS_SUCCESS:
      return { ...state, assignmentInProgress: false };
    case ASSIGN_VOUCHERS_ERROR:
      return { ...state, assignmentInProgress: false, assignmentError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const clearState = () => ({ type: CLEAR_STATE });

export const fetchUsersRequest = () => ({ type: FETCH_USERS_REQUEST });
export const fetchUsersSuccess = users => ({ type: FETCH_USERS_SUCCESS, payload: users });
export const fetchUsersError = error => ({ type: FETCH_USERS_ERROR, payload: error, error: true });

export const fetchVouchersRequest = () => ({ type: FETCH_VOUCHERS_REQUEST });
export const fetchVouchersSuccess = vouchers => ({ type: FETCH_VOUCHERS_SUCCESS, payload: vouchers });
export const fetchVouchersError = error => ({ type: FETCH_VOUCHERS_ERROR, payload: error, error: true });

export const assignVouchersRequest = () => ({ type: ASSIGN_VOUCHERS_REQUEST });
export const assignVouchersSuccess = () => ({ type: ASSIGN_VOUCHERS_SUCCESS });
export const assignVouchersError = error => ({ type: ASSIGN_VOUCHERS_ERROR, payload: error, error: true });

// ================ Thunks ================ //

/**
 * Fetch all users from Sharetribe API
 */
export const fetchUsers = () => (dispatch) => {
  dispatch(fetchUsersRequest());
  
  return get('/api/users')
    .then(response => {
      dispatch(fetchUsersSuccess(response.data));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(fetchUsersError(error));
      throw error;
    });
};

/**
 * Fetch all vouchers from the system
 */
export const fetchVouchers = () => (dispatch) => {
  dispatch(fetchVouchersRequest());
  
  return get('/api/vouchers')
    .then(response => {
      dispatch(fetchVouchersSuccess(response.data));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(fetchVouchersError(error));
      throw error;
    });
};

/**
 * Assign vouchers to multiple users
 */
export const assignVouchersToUsers = ({ userIds, voucherId }) => (dispatch) => {
  dispatch(assignVouchersRequest());
  
  return post('/api/vouchers/assign', {
    userIds,
    voucherId
  })
    .then(response => {
      dispatch(assignVouchersSuccess());
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(assignVouchersError(error));
      throw error;
    });
};

// ================ Page data loading ================ //

export const loadData = () => (dispatch) => {
  return Promise.all([
    dispatch(fetchUsers()),
    dispatch(fetchVouchers())
  ]);
};